import 'react-app-polyfill/stable';
import 'core-js';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { persistor } from '../src/redux/store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

const checkForUpdates = () => {
  fetch('/version.txt', { cache: 'no-store' })
    .then((res) => res.text())
    .then((latestVersion) => {
      const storedVersion = localStorage.getItem('app_version');
      if (storedVersion && storedVersion !== latestVersion.trim()) {
        localStorage.setItem('app_version', latestVersion.trim());
        window.location.reload(); // Reload when a new version is detected
      } else {
        localStorage.setItem('app_version', latestVersion.trim());
      }
    })
    .catch((err) => console.error('Version check failed:', err));
};

// Check for updates when the app loads
checkForUpdates();

// Check for updates every 60 seconds
setInterval(checkForUpdates, 60000);

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename="/app">
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
